import PropTypes from 'prop-types';

const bookingInfoShape = PropTypes.shape({
  bookOnBehalfOf: PropTypes.shape({
    email: PropTypes.string,
    guest_name: PropTypes.string,
    mobile_number: PropTypes.string,
  }),
  cancellationPolicy: PropTypes.arrayOf(
    PropTypes.string
  ),
  request: PropTypes.shape({
    partySize: PropTypes.number,
  }),
  reservation: PropTypes.shape({
    event: PropTypes.shape({
      title: PropTypes.string,
    }),
    type: PropTypes.string,
  }),
  venue: PropTypes.shape({
    contact: PropTypes.shape({
      phone: PropTypes.string,
      url: PropTypes.string,
    }),
    images: PropTypes.arrayOf(PropTypes.string),
    location: PropTypes.shape({
      address1: PropTypes.string,
      city: PropTypes.string,
      postalCode: PropTypes.string,
      state: PropTypes.string,
    }),
    name: PropTypes.string,
    partnershipBranding: PropTypes.shape({
      logo: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
});

export default bookingInfoShape;
